import { render, staticRenderFns } from "./Allcase.vue?vue&type=template&id=25e6dd6c&"
import script from "./Allcase.vue?vue&type=script&lang=js&"
export * from "./Allcase.vue?vue&type=script&lang=js&"
import style0 from "./Allcase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports